import LazyLoad from 'vanilla-lazyload'

const init = () => {
    const lazyInstance = new LazyLoad();
    // console.log(lazyInstance);
}

export default init;
